import React from "react";

const Separator = function (props) {
    return <div style={{borderBottom: '1px solid #ddd', margin: '20px 0px 20px 0px'}}>
    </div>
};


export {Separator}